import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { UrlService } from 'src/app/services/util/url.service';
import { Subject } from 'rxjs';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { EndpointType } from 'src/app/models/endpoint-type';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { Attributes, Datazone, Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];
@Component({
    selector: 'app-view-instance-details',
    templateUrl: './view-instance-details.component.html',
    styleUrls: ['./view-instance-details.component.scss'],
    standalone: false
})
export class ViewInstanceDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  public rightExpanded: boolean;
  displayedColumns: string[] = ['subscriptionId', 'subscriptionName', 'dataZone'];
  solutionDisplayedColumns: string[] = ['name', 'value'];

  RouterSegments = RouterSegments;

  instanceId: string;
  tenantId: string;
  changeId: string;
  solutionId: string;
  data: any;
  solution: any;
  taskInfo: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  isLoading = true;

  configTypeEndpoints: any;
  accessTypeEndpoints: any;
  exploreTypeEndpoints: any;
  otherTypeEndpoints: any;
  isEndpointAvailable = false;
  blueprintId: any;
  changeTaskId: string;
  serviceName: any;
  isActivityInProgress: any;
  isComponentAvailable = false;
  activeComponents: any;
  DeployStatus = DeployStatus;
  isAMR: boolean;
  viewReleaseNotes: string;
  latestReleaseVersion: any;
  devDeploymentClass = DeploymentClass.D;
  solutionVersions: any[];
  serviceVersionsInfo: SolutionVersionsInfo;
  permissionsMap: { [key: string]: boolean };
  
  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.OPERATION_INPROGRESS
  ];

  statusIcons = {
    deployed: 'done',
    failed: 'close',
    terminated: 'error_outline',
    inprogress: 'change_circle',
    operation_inprogress: 'change_circle',
  };
  blueprint: any;

  private afterClosed$ = new Subject<any>();
  constructor(public dateTimeFormatService: DateTimeFormatService, private toastrService: CustomToastrService,
    public urlService: UrlService , private sidenavService: SidenavService, private activatedRoute: ActivatedRoute,
    private instanceService: InstancesService, private solutionsService: SolutionsService, private router: Router,
    private authService: AuthService, 
    private toastrErrorService: ToastrErrorService, private solutionVersionsService: SolutionVersionsService, private blueprintsService: BlueprintsService,
    private permissionsService: PermissionsService) {
      
  }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.DISASTER_RECOVERY';
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    const tenant = this.authService.principal.provider;
    if (!this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]) {
      this.router.navigate(['/', tenant, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.changeId = this.activatedRoute.snapshot.params.changeId;
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.getInstanceDetails();
    this.getBlueprint(this.blueprintId);
  }

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.breadcrumbItems.push(
            {label: this.data.name}
          )
          // this.breadcrumbItems.push({label: data.name, url: [RouterSegments.EXTERNAL_INSTANCE, data.id]});
          this.data.solution = data;
          this.getInstanceDetailsById();
          this.getSolutionById(this.data.solutionId);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
      this.isLoading = false;
  }

  getBlueprint(blueprintId): void {
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprints => {
        this.serviceName = blueprints.find(item => item.id === blueprintId)?.name;
        this.blueprint = blueprints.find(item => item.id === blueprintId);
        if (this.breadcrumbItems[0]) {
          this.breadcrumbItems = [];
        }
        this.breadcrumbItems.push(
          {label: translate('TENANT_LAYOUT.MENU.DISASTER_RECOVERY'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.DISASTER_RECOVERY]},
          {label: this.serviceName, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.DISASTER_RECOVERY, this.blueprintId]},
          {label: this.data.name}
        )
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }


  getInstanceDetailsById(): void {
    this.instanceService.getInstanceDetailsById(this.data?.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data.details = data;
          this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(this.solution, this.solutionVersions, data);
          const liveInstance = this.data.details.find(instance => instance.deploymentClass === DeploymentClass.A);
            if (liveInstance) {
              this.latestReleaseVersion = this.solutionVersions.filter(version =>
                version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
            } else {
              const instanceLength = data.length;
              const latestInstanceSolutionVersion = data[instanceLength - 1]?.solutionVersionId;
              this.latestReleaseVersion = this.solutionVersions.filter(version =>
                version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
            }

          let releaseVersionText;
            if (this.latestReleaseVersion) {
              releaseVersionText = this.latestReleaseVersion;
            } else {
              releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
            }
            this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
        }
      },
      (error) => {
        // this.toastrService.clear();
      // setTimeout(() => {
      //   this.toastrService.errorMessage(
      //     `${error?.message ? error?.message : (error?.error?.message ? error?.error?.message
      //       : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')))}`
      //     );
      // }, 500);
      });
  }

  getSolutionById(solutionId): void {
    this.solutionsService.getSolutionById(solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.solution = result;
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getRleaseVersions(solutionId,targetSolutionVersionId): void {
    if(targetSolutionVersionId) {
      this.solutionsService.getSolutionVersion(solutionId, targetSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(task => {
        this.taskInfo = task;
        this.latestReleaseVersion = task.releaseVersion;
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }
  }

  navigateToChangeTask(event): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE, 
      event?.taskInfo.solutionId, this.instanceId, this.changeTaskId, RouterSegments.INSTANCE
    ]);
  }

  goToInstances(): void {
    const drBlueprint = JSON.parse(localStorage.getItem('DrBlueprint'));
    const blueprintId = this.instanceId === drBlueprint.id ? drBlueprint.blueprintId : this.blueprintId;
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.DISASTER_RECOVERY, blueprintId]);
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.CONTINUOUS_UPGRADE')},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), url: ['updates-solution']},
      {label: (this.solution?.name ? this.solution?.name : '') + ' - ' + translate('LEFT_SIDE_NAV.VIEW_TENANTS'),
      url: [RouterSegments.SOLUTIONS, this.solutionId]},
      {label: this.taskInfo?.tenantId ? this.taskInfo?.tenantId : '', url: [RouterSegments.SOLUTIONS,
         this.solutionId, this.blueprintId, this.changeId, this.tenantId, RouterSegments.INSTANCE]},
      {label: this.data.name});
  }

  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  getBuildVersion(solutionVersionId: any): any {
    // const solnVersion = this.serviceVersions?.find(v => v.id === solutionVersionId);
    // return solnVersion?.releaseVersion;
  }

}
